export class BooleanInverseValueConverter {
    toView(value, isNullNotFalse) {
        if(!isNullNotFalse){
            return !value;
        }
        return isNullNotFalse && value == null ? false : !value;
    }

    fromView(value) {
        return !value;
    }
}